import { z } from 'zod';
import { PartnerUserTypeSchema } from '../../../../entities/user';
import { ErrorCode } from '../../../../shared/error-codes';
/**
 * Manually invite a person into the partner tenant by email (the non-HubSpot
 * path). Partner tenants are kept deliberately simple — no departments or
 * Stellen — so this only carries the basics plus the partner role and an
 * optional free-text position. The generic add-org-member endpoint can't be
 * reused here because it requires a department for internal members.
 */ export const CreatePartnerMemberRequestSchema = z.object({
    firstName: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    lastName: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    email: z.email(ErrorCode.USER_INVALID_EMAIL),
    jobTitle: z.string().optional(),
    userType: PartnerUserTypeSchema
});
export const CreatePartnerMemberResponseSchema = z.object({
    success: z.boolean()
});

//# sourceMappingURL=create-partner-member.schema.js.map